"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'wix-search-widget' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 99 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'wix-search-widget' });
    }
    ;
    /**
    * @typedef {Object} loadingFinishedParams
    * @property {string} error - error message
    * @property {number} loadingDuration - time  between loading.started and loading.finished,ms
    * @property {boolean} success - True|False
    **/
    /**
     * Name: searchResults.loading.finished. Evid: 302.
     * Event description: Event should be sent when widget rendering finished.
    
     * error - Type: string. Desc: error message
     *
     * loadingDuration - Type: numeric. Desc: time  between loading.started and loading.finished,ms
     *
     * success - Type: bool. Desc: True|False
     * @param {loadingFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loadingFinished = function (params) {
        return this.bi.log(__assign({ evid: 302 }, params));
    };
    /**
    * @typedef {Object} documentTypeChangeParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {boolean} isDemo - True|False
    * @property {string} source - ViewAll|Tab
    * @property {string} target - all|pages|products|blogPosts
    **/
    /**
     * Name: searchResults.tab.changed. Evid: 306.
     * Event description: Event should be sent on result tab click (one of All/Pages/Products/BlogPost) or viewAll.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * isDemo - Type: bool. Desc: True|False
     *
     * source - Type: string. Desc: ViewAll|Tab
     *
     * target - Type: string. Desc: all|pages|products|blogPosts
     * @param {documentTypeChangeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.documentTypeChange = function (params) {
        return this.bi.log(__assign({ evid: 306 }, params));
    };
    /**
    * @typedef {Object} searchRequestStartedParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {string} documentType - pages|products|blog
    * @property {boolean} isDemo - True|False
    * @property {string} orderingDirection - Ordering direction, one of:  ASC, DESC.
    * @property {string} orderingFieldName - Ordering field name
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: searchResults - request was sent to server. Evid: 303.
     * Event description: Should be sent after visitor has been submitted search and request was sent to server.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * documentType - Type: string. Desc: pages|products|blog
     *
     * isDemo - Type: bool. Desc: True|False
     *
     * orderingDirection - Type: string. Desc: Ordering direction, one of:  ASC, DESC.
     *
     * orderingFieldName - Type: string. Desc: Ordering field name
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchRequestStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchRequestStarted = function (params) {
        return this.bi.log(__assign({ evid: 303 }, params));
    };
    /**
    * @typedef {Object} documentClickParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {string} documentType - all|pages|products|blogPosts
    * @property {boolean} isDemo - True|False
    * @property {string} pageUrl - URL
    * @property {string} resultsArray - {"all":17, "pages":5, "products":2, "blog":10}
    * @property {number} searchIndex - index of the clicked item from search result set (search_index starts from 0)
    * @property {string} target - page title
    **/
    /**
     * Name: searchResults.results.click. Evid: 305.
     * Event description: Event should be sent on visitor's click on Search Result.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * documentType - Type: string. Desc: all|pages|products|blogPosts
     *
     * isDemo - Type: bool. Desc: True|False
     *
     * pageUrl - Type: string. Desc: URL
     *
     * resultsArray - Type: string. Desc: {"all":17, "pages":5, "products":2, "blog":10}
     *
     * searchIndex - Type: numeric. Desc: index of the clicked item from search result set (search_index starts from 0)
     *
     * target - Type: string. Desc: page title
     * @param {documentClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.documentClick = function (params) {
        return this.bi.log(__assign({ evid: 305 }, params));
    };
    /**
    * @typedef {Object} loadingStartedParams
    
    **/
    /**
     * Name: searchResults.loading.started. Evid: 301.
     * Event description: Should be sent after visitor has been redirected to the search results page and rendering process for widget started.
    
    
     * @param {loadingStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loadingStarted = function (params) {
        return this.bi.log(__assign({ evid: 301 }, params));
    };
    /**
    * @typedef {Object} searchRequestFinishedParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {string} documentType - pages|products|blog
    * @property {string} error - error message
    * @property {boolean} isDemo - True|False
    * @property {number} loadingDuration - time between request.sent and request.resultReceived
    * @property {string} orderingDirection - Ordering direction, one of: ASC, DESC.
    * @property {string} orderingFieldName - Ordering field name
    * @property {number} resultCount - result count for specific document type
    * @property {string} resultsArray - {"all":17, "pages":5, "products":2, "blog":10}
    * @property {boolean} success - true|false
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: SearchResults - request result was received. Evid: 304.
     * Event description: Should be sent after visitor has been submitted search and request result was received.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * documentType - Type: string. Desc: pages|products|blog
     *
     * error - Type: string. Desc: error message
     *
     * isDemo - Type: bool. Desc: True|False
     *
     * loadingDuration - Type: numeric. Desc: time between request.sent and request.resultReceived
     *
     * orderingDirection - Type: string. Desc: Ordering direction, one of: ASC, DESC.
     *
     * orderingFieldName - Type: string. Desc: Ordering field name
     *
     * resultCount - Type: numeric. Desc: result count for specific document type
     *
     * resultsArray - Type: string. Desc: {"all":17, "pages":5, "products":2, "blog":10}
     *
     * success - Type: bool. Desc: true|false
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchRequestFinishedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchRequestFinished = function (params) {
        return this.bi.log(__assign({ evid: 304 }, params));
    };
    /**
    * @typedef {Object} searchSubmitParams
    * @property {GUID} correlationId - guid should be unique for the search per visitor
    * @property {boolean} isDemo - True|False
    * @property {string} target - what does user search for (term, phrase, word)
    **/
    /**
     * Name: searchResults.search.submit. Evid: 300.
     * Event description: Should be sent after visitor submitted search in Search Result by clicking 'Enter'.
    
     * correlationId - Type: guid. Desc: guid should be unique for the search per visitor
     *
     * isDemo - Type: bool. Desc: True|False
     *
     * target - Type: string. Desc: what does user search for (term, phrase, word)
     * @param {searchSubmitParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchSubmit = function (params) {
        return this.bi.log(__assign({ evid: 300 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 99,
        endpoint: 'wix-search-widget'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map